import { HandlerEvent } from 'post-robot';
import { dumpLongTasks } from 'communicator/utils/instrumentation-long-task';
import { PerformanceLogPayload } from 'types/instrumentation';
import pushEvents from './push-events';

const queue: HandlerEvent<PerformanceLogPayload>[] = [];

const flushQueue = () => {
  const event: {
    [index: string]: EpochTimeStamp | string;
  } = {
    E: 'BATCHED_PERFORMANCE_LOG',
    TY: 'PERFORMANCE'
  };

  while (queue.length > 0) {
    const e = queue.shift();

    if (e) {
      const d = e.data;
      event[d.E] = d.TTAKEN;
    }
  }

  pushEvents({
    source: window,
    origin: window.location.origin,
    data: event
  });

  dumpLongTasks();
};

export default function queueEvents(event: HandlerEvent<PerformanceLogPayload>) {
  const { doFlush } = {
    doFlush: false,
    ...event.data.options
  };

  queue.push(event);

  if (doFlush) {
    flushQueue();
  }
}
